import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/colecoes/$colecaoId',
)({
  component: function ColecaoLayout() {
    return <Outlet />
  },
})
